import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ADR_EDIT } from "../../_constants/actionConstants";
import "./styles/addOperatorModal.css";
import { getLaborOption, getEquipCodeLine } from "./utils/adrUtilsV3.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class EditOperatorsModalV3 extends Component {
  state = {
    formData: {
      equipment: {},
      assignSameOperator: false,
      /** @type {import("../../_typedefs/adrV3TypeDefs").OperatorBreakdown[]} */
      operatorsByWp: [],
    },
    selectedLaborIds: [],
  };

  componentDidMount() {
    const {
      workPerformedClient: wpc,
      equipmentSetRow,
      laborSetClient,
      equipmentId,
      projLaborList,
      projEquipList,
    } = this.props;

    const equipment = (projEquipList || []).find((e) => e.equipmentId === equipmentId);

    /** @type {import("../../_typedefs/adrV3TypeDefs").OperatorBreakdown[]} */
    let operatorsByWp = [];

    // Populate the operator breakdown list.
    if (equipmentSetRow.equipmentHours) {
      for (const wpTabId in equipmentSetRow.equipmentHours) {
        const opIds = equipmentSetRow.equipmentHours[wpTabId]?.operatorIds || [];
        const operators = opIds
          .map((id) => (projLaborList || []).find((l) => l.laborId === id))
          .filter(Boolean);
        operatorsByWp.push({
          wpTabId,
          wpFullCaption: wpc[wpTabId].wpFullCaption,
          isIdle: wpc[wpTabId].isIdle,
          operatorIds: operators.map((o) => o.laborId),
          selectedOperators: operators.map((o) => getLaborOption(o)),
          totalHours: equipmentSetRow.equipmentHours[wpTabId]
            ? +equipmentSetRow.equipmentHours[wpTabId].regHours +
              +equipmentSetRow.equipmentHours[wpTabId].otHours
            : 0,
        });
      }
    }

    const selectedLaborIds = Object.values(laborSetClient)
      .filter((l) => l.laborId)
      .map((l) => l.laborId);

    this.setState({
      formData: { ...this.state.formData, equipment, operatorsByWp },
      selectedLaborIds,
    });
  }

  handleChange_operator = (rowIndex) => (selectedOperators) => {
    let formData = {
      ...this.state.formData,
      operatorsByWp: this.state.formData.operatorsByWp.map((obw) => ({ ...obw })),
    };

    const selected = selectedOperators || [];
    formData.operatorsByWp[rowIndex].selectedOperators = selected;
    formData.operatorsByWp[rowIndex].operatorIds = selected.map((o) => o.value);

    this.setState({ formData });
  };

  handleSubmit = (e) => {
    const { dispatch, tabId, rowKey, toggleEditOperatorsModal, markAdrDirty } =
      this.props;
    const { operatorsByWp } = this.state.formData;
    e.preventDefault();

    /** @type {Object.<number, number[]>} Keys are wpTabId, values are arrays of laborIds */
    const operatorData = {};
    operatorsByWp.forEach((opByWp) => {
      operatorData[opByWp.wpTabId] = opByWp.operatorIds || [];
    });
    dispatch({
      type: ADR_EDIT.EQUIPMENTSET.OPERATOR.UPDATE,
      tabId,
      rowKey,
      operatorData,
    });
    toggleEditOperatorsModal();
    markAdrDirty();
  };

  renderOperatorData = (opRow, rowIndex) => {
    return (
      <tr key={`opRowKey_${rowIndex}`}>
        <td className="td-item">{opRow.wpFullCaption}</td>
        <td className="td-operator">
          {!opRow.isIdle
            ? this.renderOperatorSelectors(opRow.selectedOperators, rowIndex)
            : this.renderIdleBox(rowIndex)}
        </td>
        <td className="td-hours">{opRow.totalHours}</td>
      </tr>
    );
  };

  renderOperatorSelectors = (selectedOperators, rowIndex) => {
    const { projLaborList } = this.props;
    const { formData, selectedLaborIds } = this.state;
    if (formData.assignSameOperator) {
      if (rowIndex === 0)
        return (
          <Select
            name={`operatorSelect_${rowIndex}`}
            id={`operatorSelectId_${rowIndex}`}
            isMulti
            value={selectedOperators}
            options={(projLaborList || [])
              .filter((l) => selectedLaborIds.includes(l.laborId))
              .map((l) => getLaborOption(l))}
            onChange={this.handleChange_operator(rowIndex)}
            isClearable
            placeholder="(No Operator Selected)"
          />
        );
      else
        return (
          <Select
            name={`operatorSelect_${rowIndex}`}
            id={`operatorSelectId_${rowIndex}`}
            isMulti
            value={selectedOperators}
            options={[]}
            onChange={this.handleChange_operator(rowIndex)}
            isDisabled={true}
            placeholder="(No Operator Selected)"
          />
        );
    }
    return (
      <Select
        name={`operatorSelect_${rowIndex}`}
        id={`operatorSelectId_${rowIndex}`}
        isMulti
        value={selectedOperators}
        options={(projLaborList || [])
          .filter((l) => selectedLaborIds.includes(l.laborId))
          .map((l) => getLaborOption(l))}
        onChange={this.handleChange_operator(rowIndex)}
        isClearable
        placeholder="(No Operator Selected)"
      />
    );
  };

  renderIdleBox = (rowIndex) => {
    return (
      <input
        type="text"
        name={`operatorSelect_${rowIndex}`}
        id={`operatorSelect_${rowIndex}`}
        className="form-control"
        value="Idle"
        disabled
      />
    );
  };

  formIsIncomplete = () => {};

  render() {
    const { showEditOperatorsModal, toggleEditOperatorsModal } = this.props;
    const { formData } = this.state;

    const closeBtn = (
      <button className="close" onClick={toggleEditOperatorsModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );

    return (
      <Modal
        isOpen={showEditOperatorsModal}
        toggle={toggleEditOperatorsModal}
        className={this.props.className}
        fade={false}
        size={"lg"}
      >
        <ModalHeader
          toggle={toggleEditOperatorsModal}
          className="bg-info text-white"
          close={closeBtn}
        >
          Add/Edit Operator(s)
        </ModalHeader>
        <ModalBody>
          <form id="addOperatorForm" onSubmit={this.handleSubmit} autoComplete="off">
            <div className="card mx-2 mb-2 bg-lightgray">
              <div className="card-body">
                <div className="form-row">
                  <label className="col-sm-3 col-form-label">
                    <strong>Operated Equipment:</strong>
                  </label>
                  <div className="col-sm-5">
                    <input
                      type="text"
                      id="equipment"
                      name="equipment"
                      className="form-control"
                      readOnly
                      value={getEquipCodeLine(formData.equipment)}
                      onChange={() => {}}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card mx-2">
              <div className="card-body pb-0">
                <table className="table">
                  <thead>
                    <tr>
                      <th>
                        <b>Item/CCO</b>
                      </th>
                      <th>
                        <b>Operator</b>
                      </th>
                      <th>
                        <b>Hours</b>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.operatorsByWp.map((op, index) =>
                      this.renderOperatorData(op, index)
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter className="bg-lightgray">
          <div className="form-row form-group mb-0">
            <input
              className="btn btn-primary"
              name="addOperator"
              type="submit"
              form="addOperatorForm"
              onClick={this.handleSubmit}
              value="Apply"
            />
            <button
              className="btn btn-secondary ml-2"
              color="secondary"
              onClick={toggleEditOperatorsModal}
            >
              Cancel
            </button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  laborSetClient: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].laborSetClient || []
    : null,
  equipmentSetClient: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].equipmentSetClient || null
    : null,
  workPerformedClient: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].workPerformedClient || null
    : null,
  projEquipList: state.equipment.projEquipLists[ownProps.projectId] || null,
  projLaborList: state.labors.projLaborLists[ownProps.projectId] || null,
});

export default connect(mapStateToProps)(EditOperatorsModalV3);
